import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50/50 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src="/laclive-logo-sm.webp" alt="LacLive - naturally tolerant" className="h-12 w-auto" />
          </div>
          <p className="text-slate-600 max-w-md leading-relaxed">
            Wissenschaftlich fundierte Informationen zur Lactoseintoleranz - für ein normales, freies Leben ohne unnötigen Verzicht.
          </p>
          <p className="text-xs text-slate-400 mt-6">
            Hinweis: LacLive ersetzt keine medizinische Beratung. Bei anhaltenden Beschwerden konsultieren Sie bitte einen Arzt.
          </p>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-slate-900 mb-4">Themen</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/ueber-lactoseintoleranz" className="hover:text-emerald-700">Über Lactoseintoleranz</Link></li>
            <li><Link to="/mythen-und-fakten" className="hover:text-emerald-700">Mythen & Fakten</Link></li>
            <li><Link to="/ernaehrung" className="hover:text-emerald-700">Ernährung & Toleranz</Link></li>
            <li><Link to="/artikel" className="hover:text-emerald-700">Artikel</Link></li>
            <li><Link to="/wissenschaft" className="hover:text-emerald-700">Wissenschaft (Deep-Dive)</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-sm font-semibold text-slate-900 mb-4">Rechtliches</h4>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/kontakt" className="hover:text-emerald-700">Kontakt</Link></li>
            <li><Link to="/impressum" className="hover:text-emerald-700">Impressum</Link></li>
            <li><Link to="/datenschutz" className="hover:text-emerald-700">Datenschutz</Link></li>
            <li><Link to="/agb" className="hover:text-emerald-700">AGB</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between text-xs text-slate-500">
          <span>© {new Date().getFullYear()} LacLive. Alle Rechte vorbehalten.</span>
          <span>Made with care.</span>
        </div>
      </div>
    </footer>
  );
}
